import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const RecipesIAContainer = styled.div`
  width: 100%;
  min-height: 152px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  background-color: ${Color.greyF5F5F5};
  ${breakpoints.phone} {
    flex-direction: column;
    height: auto;
    padding: 15px;
    gap: 20px;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background-color: ${ColorDark.darkGrey};
    }
  }
  .recipes-ia-info {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    ${breakpoints.phone} {
      width: 100%;
      gap: 10px;
      justify-content: flex-start;
    }
    .recipes-ia-icon {
      background-color: ${Color.yellow2};
      width: 110px;
      height: 110px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      img {
        width: 80px;
        height: 80px;
      }
      ${breakpoints.tablet} {
        width: 74px;
        height: 74px;
        img {
          width: 53px;
          height: 53px;
        }
      }
      ${breakpoints.phone} {
        width: 74px;
        height: 74px;
        img {
          width: 53px;
          height: 53px;
        }
      }
    }
    .recipes-ia-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      ${breakpoints.phone} {
        width: 70%;
      }
      .recipes-ia-text-title {
        ${Font.sansBold}
        font-size: 25px;
        line-height: 32px;
        color: ${Color.black000};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
            background-color: ${ColorDark.darkGrey};
          }
        }
        ${breakpoints.tablet} {
          font-size: 20px;
          line-height: 25px;
        }
        ${breakpoints.phone} {
          font-size: 20px;
          line-height: 25px;
        }
      }
      .recipes-ia-text-content {
        ${Font.sansRegular}
        font-size: 15px;
        line-height: 21px;
        color: ${Color.grey};
        ${breakpoints.tablet} {
          font-size: 15px;
          line-height: 20px;
        }
        ${breakpoints.phone} {
          font-size: 13px;
          line-height: 18px;
        }
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.grey};
          }
        }
      }
    }
  }
  .recipes-ia-chat-container {
    width: 75%;
    display: flex;
    flex-direction: column;
    ${breakpoints.tablet} {
      width: 50%;
    }
    ${breakpoints.phone} {
      width: 100%;
    }
  }
  .recipes-ia-chat-bubble {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    ${breakpoints.phone} {
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .recipes-ia-chat-bubble.type-ia {
    justify-content: flex-start;
    ${breakpoints.phone} {
      flex-direction: column-reverse;
      align-items: flex-start;
      justify-content: center;
    }
  }
  .recipes-ia-chat-message {
    ${Font.sansRegular};
    font-size: 18px;
    line-height: 24px;
    border-radius: 10px;
    max-width: 80%;
    padding: 8px 12px;
    margin: 5px 0;
    ${breakpoints.phone} {
      max-width: 100%;
    }
  }
  .recipes-ia-chat-message.type-ia,
  .recipes-ia-chat-message.type-user {
    min-height: 67px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 13px 20px;
  }
  .recipes-ia-chat-message.type-ia {
    background-color: ${Color.yellow2};
    margin-right: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    ol {
      padding-left: 10px;
    }
    h1 {
      ${Font.sansBold};
    }
    ${breakpoints.phone} {
      margin-bottom: 16px;
    }
    :after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-right-color: ${Color.yellow2};
      border-left: 0;
      margin-top: -10px;
      margin-left: -10px;
      ${breakpoints.phone} {
        all: unset;
        content: "";
        position: absolute;
        bottom: 0;
        left: 20px;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-top-color: ${Color.yellow2};
        border-bottom: 0;
        margin-left: -10px;
        margin-bottom: -8px;
      }
    }
  }
  .recipes-ia-chat-message.type-user {
    background-color: ${Color.white};
    margin-left: auto;
    text-align: right;
    height: 67px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 13px 20px;
    position: relative;
    ${breakpoints.phone} {
      margin-bottom: 16px;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-left-color: ${Color.white};
      border-right: 0;
      margin-top: -10px;
      margin-right: -10px;
      ${breakpoints.phone} {
        all: unset;
        content: "";
        position: absolute;
        bottom: 0;
        right: 10%;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-top-color: ${Color.white};
        border-bottom: 0;
        margin-left: -10px;
        margin-bottom: -8px;
      }
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.greySeparator};
        color: ${Color.white};
        &:after {
          border-top-color: ${ColorDark.greySeparator};
        }
      }
    }
  }
  .recipes-ia-input-container {
    background-color: ${Color.white};
    //border: 1px solid ${Color.greySeparator};
    border-radius: 50px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${Color.greySeparator};
    padding-right: 10px;
    ${breakpoints.phone} {
      padding-right: 7px;
      width: 100%;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.darkGrey};
        border: 1px solid ${ColorDark.grey};
      }
    }

    .recipes-ia-form {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 0;
    }
    .recipes-ia-input {
      width: 100%;
      height: 62px;
      border-radius: 50px;
      background-color: ${Color.white};
      border: none;
      padding: 20px 48px;
      ${Font.sansRegular}
      font-size: 18px;
      line-height: 21px;
      color: ${Color.grey};
      position: relative;
      outline: none;
      ${breakpoints.phone} {
        padding: 5px 20px;
        font-size: 15px;
        line-height: 21px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background-color: ${ColorDark.darkGrey};
        }
      }
    }
    .recipes-ia-input-button {
      width: 54px;
      height: 50px;
      background: #fddf37;
      border-radius: 50%;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding-top: 3px;
      ${breakpoints.phone} {
        width: 50px;
        height: 45px;
      }
    }
  }
  .recipes-ia-chat-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Color.yellow2};
    border-radius: 50%;
    margin: 0;
    margin-right: 16px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .recipes-ia-chat-icon.type-user {
    background-color: ${Color.grey};
    margin-right: 0;
    margin-left: 16px;
  }
  //animacion cargando
  .recipes-ia-loading-chat {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
    ${breakpoints.phone} {
      flex-direction: column-reverse;
      justify-content: center;
      align-items: flex-start;
    }
    .recipes-ia-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 45px;
      height: 9px;
      margin-left: -22px;
      margin-top: -13px;
      text-align: center;
    }
    .recipes-ia-spinner > div {
      width: 9px;
      height: 9px;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
      animation: bouncedelay 1400ms ease-in-out infinite;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
    .recipes-ia-spinner .recipes-ia-bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }
    .recipes-ia-spinner .recipes-ia-bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
    @-webkit-keyframes bouncedelay {
      0%,
      80%,
      100% {
        transform: scale(0);
        -webkit-transform: scale(0);
      }
      40% {
        transform: scale(1);
        -webkit-transform: scale(1);
      }
    }
    @keyframes bouncedelay {
      0%,
      80%,
      100% {
        transform: scale(0);
        -webkit-transform: scale(0);
      }
      40% {
        transform: scale(1);
        -webkit-transform: scale(1);
      }
    }
    .recipes-ia-loading-container {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      ${breakpoints.phone} {
        margin-bottom: 16px;
      }
    }
    .recipes-ia-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      height: auto;
      min-width: 73px;
      min-height: 40px;
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      background-color: ${Color.yellow2};
      &:before {
        display: block;
        content: " ";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 8px 8px 0;
        border-color: transparent ${Color.yellow2} transparent transparent;
        position: absolute;
        left: -7px;
        top: 13px;
        ${breakpoints.phone} {
          top: unset;
          bottom: -16px;
          left: 11px;
          border-width: 8px 8px 8px 8px;
          border-color: ${Color.yellow2} transparent transparent transparent;
        }
      }
      .recipes-ia-spinner {
        position: static !important;
        margin-top: -11px;
        margin-left: 0px;
        div {
          background-color: ${Color.black};
        }
      }
      -webkit-animation: message-bounce 2.5s infinite ease-in-out;
      animation: message-bounce 2.5s ease-in-out infinite;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
    @keyframes message-bounce {
      0% {
        transform: scale(0.9);
        -webkit-transform: scale(0.9);
      }
      50% {
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
      }
      100% {
        transform: scale(0.9);
        -webkit-transform: scale(0.9);
      }
    }
  }
  .recipes-ia-error {
    ${Font.sansRegular};
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
    margin-left: 20px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
`;
